import { useState, useSyncExternalStore } from 'react';

/** A local mirror is not a receipt. Each dispatched write owns its settlement. */
export function useUnconfirmedWrites() {
  const [writes] = useState(() => {
    const pending = new Map<symbol, { key?: string; revision: number }>();
    let revision = 0;
    const listeners = new Set<() => void>();
    const publish = () => listeners.forEach(listener => listener());
    return {
      subscribe: (listener: () => void) => { listeners.add(listener); return () => { listeners.delete(listener); }; },
      snapshot: () => pending.size > 0,
      getRevision: () => revision,
      begin: (key?: string) => {
        const ticket = Symbol('unconfirmed-write');
        const issued = ++revision;
        pending.set(ticket, { key, revision: issued }); publish();
        return () => {
          let changed = false;
          for (const [id, write] of pending) {
            // A validated HTTP retry of the same patch also establishes the
            // outcome of earlier identical attempts, never a later/different edit.
            if (id === ticket || (key !== undefined && write.key === key && write.revision <= issued)) {
              pending.delete(id); changed = true;
            }
          }
          if (changed) publish();
        };
      },
    };
  });
  const hasUnconfirmedWrites = useSyncExternalStore(writes.subscribe, writes.snapshot, writes.snapshot);
  return { hasUnconfirmedWrites, beginUnconfirmedWrite: writes.begin, getWriteRevision: writes.getRevision };
}
